import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-stock-batch-assigned',
  templateUrl: './stock-stock-batch-assigned.component.html',
  styleUrls: ['./stock-stock-batch-assigned.component.css']
})
export class StockStockBatchAssignedComponent implements OnInit {
    stockKeyno;

    public itemsListAssigned: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadAssigned() {
        if (!!this.stockKeyno) {
            this.itemsListAssigned = await this.datatask.Post(414, { stock_keyno: this.stockKeyno });
        }
    }

    private async init() {
        this.loadAssigned();
    }

    ngOnInit() {
        this.init();
    }
}
